export default __webpack_public_path__ + "static/media/user.inline.33d1117c.svg";